export default {
  data() {
    return { submissionError: '' };
  },
  methods: {
    reportFormEvent(event, error, details) {
      if (window.formDiagnostics) {
        window.formDiagnostics.report(event, error, details);
      }
    },
    diagnosticReference() {
      return window.formDiagnostics ? ' Referencia: ' + window.formDiagnostics.sessionId : '';
    }
  }
};
